(function() { module.exports = window["wp"]["htmlEntities"]; }());